import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';

const MiniCard = ({ children, ...props }) => {
  return <StyledMiniCard {...props}>{children}</StyledMiniCard>;
};

MiniCard.propTypes = {
  children: PropTypes.node.isRequired,
};

const StyledMiniCard = styled(Box)`
  background-color: ${({ theme }) => theme.colors.secondary};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 12px;
  padding: 12px 16px 12px 16px;
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default MiniCard;
